import {
  GET_ALL_PRODUCT_STOCK_REQUEST,
  GET_ALL_PRODUCT_STOCK_SUCCESS,
  GET_ALL_PRODUCT_STOCK_FAIL,
  ADD_PRODUCT_STOCK_REQUEST,
  ADD_PRODUCT_STOCK_SUCCESS,
  ADD_PRODUCT_STOCK_FAIL,
  UPDATE_PRODUCT_STOCK_REQUEST,
  UPDATE_PRODUCT_STOCK_SUCCESS,
  UPDATE_PRODUCT_STOCK_FAIL,
  DELETE_PRODUCT_STOCK_REQUEST,
  DELETE_PRODUCT_STOCK_SUCCESS,
  DELETE_PRODUCT_STOCK_FAIL,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_PRODUCT_MESSAGES,
} from "../constants/productConstants";

const initialStockState = {
  products: [],
  loading: false,
  productStockError: null,
  productStockMessage: null,
};

export const productStockReducer = (state = initialStockState, action) => {
  switch (action.type) {
    case GET_ALL_PRODUCT_STOCK_REQUEST:
    case ADD_PRODUCT_STOCK_REQUEST:
    case UPDATE_PRODUCT_STOCK_REQUEST:
    case DELETE_PRODUCT_STOCK_REQUEST:
      return { ...state, loading: true, productStockError: null };

    case GET_ALL_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        products: Array.isArray(action.payload?.products)
          ? action.payload.products
          : [],
        productStockMessage: action.payload?.message || "",
      };

    case ADD_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        products: [...state.products, action.payload.product || action.payload],
        productStockMessage: action.payload?.message || "Product stock added successfully.",
      };

    case UPDATE_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        // Replace updated product in the list
        products: state.products.map(prod =>
          String(prod._id) === String(action.payload.product?._id || action.payload._id)
            ? (action.payload.product || action.payload)
            : prod
        ),
        productStockMessage: action.payload?.message || "Product stock updated successfully.",
      };

    case DELETE_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.filter(prod =>
          String(prod._id) !== String(action.payload.productId || action.payload._id)
        ),
        productStockMessage: action.payload?.message || "Product stock deleted successfully.",
      };

    case GET_ALL_PRODUCT_STOCK_FAIL:
    case ADD_PRODUCT_STOCK_FAIL:
    case UPDATE_PRODUCT_STOCK_FAIL:
    case DELETE_PRODUCT_STOCK_FAIL:
      return { ...state, loading: false, productStockError: action.payload };

    case CLEAR_PRODUCT_ERRORS:
      return { ...state, productStockError: null };
    case CLEAR_PRODUCT_MESSAGES:
      return { ...state, productStockMessage: null };

    default:
      return state;
  }
};
